import { CompareScreen } from '../features/console';

export function ComparePage() {
  return <CompareScreen />;
}
